import axios, { AxiosRequestConfig } from 'axios';
// config
import { HOST_API, SCHOOL_ID, AI_HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

const axiosAIInstance = axios.create({
  baseURL: AI_HOST_API,
  headers: {
    'Content-Type': 'application/json',
  }
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Đã có lỗi xảy ra !')
);

export default axiosInstance;

axiosAIInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Đã có lỗi xảy ra !')
);

export const axiosAI = axiosAIInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  auth: {
    me: '/api/users/me',
    login: '/api/auth/login',
    register: '/api/users',
    re_login: (token: string) => `/api/public/me?token=${token}`,
    refresh_token: '/api/users/auth/refresh-token',
  },
  reader: {
    root: '/api/user',
    findById: '/api/user/',
    findByAI: '/api/generate',
    create: '/api/user/create',
    creates: '/api/user/create-from-excel',
    update: '/api/user/{id}/update',
    extend: '/api/user/{id}/extend',
    delete: '/api/user/delete',
  },
  book: {
    root: '/api/book',
    find_by_id: '/api/book/',
    find_by_code: '/api//book/{id}/code',
    create: '/api/book/create',
    creates: '/api/book/create-book-form-excel',
    create_book_code: '/api/book/create-book-code',
    delete_book_code: '/api/book/delete-book-code',
    update_manage_infor: '/api//book/{id}/update-detail',
    update: '/api/book/{id}/update',
    delete: '/api/book/delete',
  },
  class: {
    root: '/api/class',
    find_by_id: '/api/class/',
    create: '/api/class/create',
    update: '/api/class/{id}/update',
    delete: '/api/class/delete',
  },
  school_year: {
    root: '/api/school-year',
    find_by_id: '/api/school-year/',
    create: '/api/school-year/create',
    update: '/api/school-year/{id}/update',
    delete: '/api/school-year/delete',
  },
  reader_group: {
    root: '/api/reader-group',
    find_by_id: '/api/reader-group/',
    create: '/api/reader-group/create',
    update: '/api/reader-group/{id}/update',
    delete: '/api/reader-group/delete',
  },
  fine_policy: {
    root: '/api/fine-policy',
    find_by_id: '/api/fine-policy/',
    create: '/api/fine-policy/create',
    update: '/api/fine-policy/{id}/update',
    delete: '/api/fine-policy/delete',
  },
  book_fine_policy: {
    root: '/api/fine-policy/with-book',
    find_by_id: '/api/fine-policy/with-book/',
    create: '/api/fine-policy/create-with-book',
    update: '/api/fine-policy/{id}/update-with-book',
    delete: '/api/fine-policy/delete-with-book',
  },
  field: {
    root: '/api/field',
    find_by_id: '/api/field/',
    create: '/api/field/create',
    update: '/api/field/{id}/update',
    delete: '/api/field/delete',
  },
  language: {
    root: '/api/language',
    find_by_id: '/api/language/',
    create: '/api/language/create',
    update: '/api/language/{id}/update',
    delete: '/api/language/delete',
  },
  publisher: {
    root: '/api/publisher',
    find_by_id: '/api/publisher/',
    create: '/api/publisher/create',
    update: '/api/publisher/{id}/update',
    delete: '/api/publisher/delete',
  },
  book_status: {
    root: '/api/book-status',
    find_by_id: '/api/book-status/',
    create: '/api/book-status/create',
    update: '/api/book-status/{id}/update',
    delete: '/api/book-status/delete',
  },
  category: {
    root: '/api/category',
  },
  book_shelf: {
    root: '/api/position',
    find_by_id: '/api/position/',
    create: '/api/position/create',
    update: '/api/position/{id}/update',
    delete: '/api/position/delete',
  },
  book_category: {
    root: '/api/category',
    find_by_id: '/api/category/',
    create: '/api/category/create',
    update: '/api/category/{id}/update',
    delete: '/api/category/delete',
  },
  loan_receipt: {
    root: '/api/loan-receipt',
    find_by_id: '/api/loan-receipt/',
    create: '/api/loan-receipt/create',
    update: '/api/loan-receipt/{id}/update',
    extend: '/api/loan-receipt/{id}/extend',
    return_book: '/api/loan-receipt/give-books-back',
    delete: '/api/loan-receipt/delete',
  },
  penalty_ticket: {
    root: '/api/penalty-ticket',
    find_by_id: '/api/penalty-ticket/',
    // create: '/api/penalty-ticket/create',
    delete: '/api/penalty-ticket/delete',
    pay: '/api/penalty-ticket/{id}/pay',
  },
  request_book: {
    root: '/api/book-request',
    find_by_id: '/api/book-request/',
    create: '/api/book-request/create',
    update: '/api/book-request/{id}/update',
    delete: '/api/book-request/delete',
  },
  setting: {
    root: '/api/setting/active',
    update: '/api/setting/update',
  },
  report_statistical: {
    borrow_return_book: '/api/report/loan-payment',
    reader_statistical: '/api/report/reader',
    book_borrow_statistical: '/api/report/loan-receipt',
    book_statistical: '/api/report/book',
  },
  common: {
    date_now: '/api/common/date-now',
    activity_log: '/api/activity',
    backup_data: '/api/common/backup',
  },
  lost_book: {
    root: '/api/book-lost',
    find_by_id: '/api/book-lost/',
    create: '/api/book-lost/create',
    update: '/api/book-lost/{id}/update',
    delete: '/api/book-lost/delete',
  },
  access_control: {
    role_group: '/api/group-role',
    permission: {
      root: '/api/permission',
      find_by_id: '/api/permission/',
      create: '/api/permission/create',
      update: '/api/permission/{id}/update',
      delete: '/api/permission/delete',
    },
  },
  account: {
    root: '/api/account',
    find_by_id: '/api/account/',
    create: '/api/account/create',
    change_password: '/api/account/me/change-password',
    update: '/api/account/{id}/update',
    delete: '/api/account/delete',
  },
  register_borrow_book: {
    root: '/api/booking-book',
    find_by_id: '/api/booking-book/',
    delete: '/api/booking-book/delete',
  },
  public: {
    find_book: `/api/public/${SCHOOL_ID}/book`,
    find_book_detail_by_ids: `/api/public/${SCHOOL_ID}/book-detail`,
    loan_book_register: `/api/public/booking/create`,
    reader_register: `/api/public/card/register`,
    comfirm_loan_book_register: '/api/public/booking/confirm',
    book: `/api/public/${SCHOOL_ID}/book/`,
    field: `/api/public/${SCHOOL_ID}/field`,
    language: `/api/public/${SCHOOL_ID}/language`,
    category: `/api/public/${SCHOOL_ID}/category`,
    reader_account_fee: `/api/public/${SCHOOL_ID}/card-opening-fee`,
    create_review: (BOOK_ID: string) => `/api/public/book/${BOOK_ID}/review`
  },
  reader_account_fee: {
    root: '/api/card-opening-fee',
    find_by_id: '/api/card-opening-fee/',
    create: '/api/card-opening-fee/create',
    update: '/api/card-opening-fee/{id}/update',
    delete: '/api/card-opening-fee/delete',
  },
  reader_register: {
    root: '/api/card-registration',
    find_by_id: '/api/card-registration/',
    confirm: '/api/card-registration/{id}/confirm',
    delete: '/api/card-registration/delete',
  },
  school: {
    root: '/api/school/me',
    update_infor: '/api/school/update',
    update_smtp: '/api/school/email/update',
  },
  forum: {
    root: '/api/forum',
    info: (forum_id: string) => `/api/forum/${forum_id}`,
    comment: (forum_id: string) => `api/forum/${forum_id}/comments`,
    delete_comment: (forum_id: string, comment_id: string) => `/api/forum/${forum_id}/comments/${comment_id}`
  }
};
